module.exports = __webpack_public_path__ + "static/media/bg01.13fa0c3f.jpg";